import { render, staticRenderFns } from "./propertyValueRow.vue?vue&type=template&id=2b330bd8&"
import script from "./propertyValueRow.vue?vue&type=script&lang=js&"
export * from "./propertyValueRow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports